import React from 'react';
import { MessageTemplate } from '../../../types/messaging';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import { ModalProps } from '../../../types/modal';
import { useDeleteMessageTemplateMutation } from '../../../../app/Slices/SevenDayApiSlice';
import toast from '../../../shared/Toast';
import { Close } from '@mui/icons-material';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';

interface DeleteTemplateModalProps extends ModalProps {
    template: MessageTemplate | null;
}

const DeleteTemplateModal = ({
    template,
    open,
    onClose,
}: DeleteTemplateModalProps) => {
    const [deleteTemplate] = useDeleteMessageTemplateMutation();

    const handleDelete = async () => {
        try {
            if (!template?.id) throw new Error();

            await deleteTemplate(template.id).unwrap();
            toast.success('Template deleted successfully');
            onClose();
        } catch (error) {
            toast.error('Error deleting message template');
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                Delete Template
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={1}>
                    <Typography>
                        Are you sure you want to delete <b>{template?.name}</b>?
                    </Typography>
                    <Alert severity='warning'>
                        This action cannot be undone
                    </Alert>
                </Stack>
            </DialogContent>
            <DialogActions>
                <CustomButton
                    variant='contained'
                    color='neutral'
                    onClick={onClose}
                >
                    Cancel
                </CustomButton>
                <Button
                    variant='contained'
                    color='error'
                    onClick={handleDelete}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteTemplateModal;
